import { types } from 'features/progressBar/store/types'

const initialState = {
  /* enum: inactive, pending, success, error */
  status: 'inactive'
}

const progressBarReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.PROGRESS_SUCCESS:
      return {
        status: 'success'
      }

    case types.PROGRESS_ERROR:
      return {
        status: 'error'
      }

    case types.PROGRESS_PENDING:
      return {
        status: 'pending'
      }

    case types.PROGRESS_INACTIVE:
      return {
        status: 'inactive'
      }

    default:
      break
  }
  return state
}

export default progressBarReducer



// WEBPACK FOOTER //
// ./src/features/progressBar/store/reducer.js